import React, { useRef } from 'react';
import { isSizeAvailable } from '../lib/products';
import { useHorizontalWheelScroll } from '../hooks/useHorizontalWheelScroll';
import './SizeSelector.css';

const ALL_SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

function SizeSelector({ sizes, selectedSize, onSelectSize }) {
  const scrollRef = useRef(null);

  useHorizontalWheelScroll(scrollRef);

  const sizeByLabel = Object.fromEntries(
    (sizes || []).map(size => [size.size_label, size])
  );

  return (
    <div
      ref={scrollRef}
      className="size-selector"
      role="listbox"
      aria-label="Select size"
    >
      {ALL_SIZES.map(label => {
        const size = sizeByLabel[label];
        const available = size ? isSizeAvailable(size) : false;
        const isSelected = selectedSize === label;

        return (
          <button
            key={label}
            type="button"
            role="option"
            aria-selected={isSelected}
            aria-disabled={!available}
            disabled={!available}
            className={`size-selector-pill${isSelected ? ' active' : ''}${!available ? ' unavailable' : ''}`}
            onClick={() => {
              if (available) {
                onSelectSize(label);
              }
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}

export default SizeSelector;
